<template>
    <div class="bg-black" id="what-we-do">
        <b-container class="py-100 d-md-block d-none">
            <p class="ga-pink gotham-book mb-1">WHAT WE DO/</p>
            <!-- <p class="h3 gotham-bold ga-pink">06 / 15</p> -->
            <b-card no-body>
                <div class="pink-divider"></div>
                <b-tabs pills card vertical end nav-wrapper-class="w-50" v-model="tabIndex">
                    <b-tab active>
                        <template #title>
                            project & corporate identity creation
                            <div class="list-bullet"></div>
                        </template>
                        <p class="text-white fade-right">
                            <span class="gotham-bold">Existing Eye Offerings </span>
                            <br>
                            <br>
                            We build brands from the ground-up, while developing existing brands to reach their full potential. With a keen eye for striking design, in-depth research, and a unique voice for every brand we build and develop, we continue to create distinctive offerings that truly drive success.  
                        </p>
                    </b-tab>
                    <b-tab>
                        <template #title>
                            print ad
                            <div class="list-bullet"></div>
                        </template>
                        <p class="text-white fade-right">
                            <span class="gotham-bold">People Print Dollars</span>
                            <br>
                            <br>
                            Some people say print ads aren't worth the marketing dollars they generate. Those are the same people who don't know how to do it right. Print ads may be a forgotten art in today's digital age, but they still remain an immensely powerful tool to have in your toolbox. And we've been practicing since the 1980's. 
                        </p>
                    </b-tab>
                    <b-tab>
                        <template #title>
                            brochure design
                            <div class="list-bullet"></div>
                        </template>
                        <p class="text-white fade-right">
                            <span class="gotham-bold">Capture Invite Influence</span>
                            <br>
                            <br>
                            When it comes to creating award-winning brochures, we do it by the book. Carefully considering every detail to produce engaging and informative pieces that capture your viewer's attention, and invites them in to discover something more. An indispensable resource that directly influences sales time after time.
                        </p>
                    </b-tab>
                    <b-tab>
                        <template #title>
                            direct mail designs & delivery
                            <div class="list-bullet"></div>
                        </template>
                        <p class="text-white fade-right">
                            <span class="gotham-bold">Egyptian Landowner Papyrus</span>
                            <br>
                            <br>
                            Ah, print and digital direct mail. The lifeblood of advertising since 1000 B.C., when an Egyptian landowner scribbled an unsavory advertisement on a piece of papyrus. We've come a long way since then no doubt, but the power and application of this timeless marketing method remains. Only now, we can generate thousands of sales and even more leads faster than ever before. Sounds easy, right?
                        </p>
                    </b-tab>
                    <b-tab>
                        <template #title>
                            website design & development
                            <div class="list-bullet"></div>
                        </template>
                        <p class="text-white fade-right">
                            <span class="gotham-bold">
                                Wizards Bring Life
                            </span>
                            <br>
                            <br>
                            Our expert web team, or Web Wizards as we call them, handle everything throughout the development, management, and maintenance processes. They work closely alongside our designers and writers to bring the visions of your ideal website to life. With creation and hosting all done in-house, it's the one-stop-shop for all your website needs.
                        </p>
                    </b-tab>
                    <b-tab>
                        <template #title>
                            social media/content
                            <div class="list-bullet"></div>
                        </template>
                        <p class="text-white fade-right">
                            <span class="gotham-bold">
                                Fingers Pulse Everything
                            </span>
                            <br>
                            <br>
                            The heart and soul of any contemporary campaign, our social media experts have their fingers on the pulse of everything #trending. From punchy, attention-grabbing posts to strategic planning, in-depth market research and more, our dedicated social team really does do it all.
                        </p>
                    </b-tab>
                    <b-tab>
                        <template #title>
                            marketing & digital advertising
                            <div class="list-bullet"></div>
                        </template>
                        <p class="text-white fade-right">
                            <span class="gotham-bold">
                                Love Secret Strategies
                            </span>
                            <br>
                            <br>
                            Marketing is our first love, and in this day and age, digital advertising is our secret weapon. From proven far-reaching marketing strategies to Search Engine Optimization, curated digital ads, Google adwords, video ads, and more, our digital campaigns are award-winning. 
                        </p>
                    </b-tab>
                    <b-tab>
                        <template #title>
                            production, installation & fabrication
                            <div class="list-bullet"></div>
                        </template>
                        <p class="text-white fade-right">
                            <span class="gotham-bold">
                                Relish Ketchup Mustard
                            </span>
                            <br>
                            <br>
                            We've got an actual workshop downstairs. That's how "full-service" we are. With an in-house Production, Installation & Fabrication team dedicated to building the retail spaces and presentation centres of your dreams, we relish the opportunity to pursue your greatest ambitions. That might sound a little cheesy, but hey, we're one ketchup and mustard pun away from making you a burger.
                        </p>
                    </b-tab>
                    <b-tab>
                        <template #title>
                            media planning
                            <div class="list-bullet"></div>
                        </template>
                        <p class="text-white fade-right">
                            <span class="gotham-bold">
                                Mr. T Planned Goals
                            </span>
                            <br>
                            <br>
                            We're not the only ones who love it when a plan comes together, Mr. T does too. Because, like us, he knows the importance and power a properly planned media schedule has on overall engagement and sales. Which is why we work closely alongside you to create effective plans that go beyond fulfilling your brand goals.
                        </p>
                    </b-tab>
                    <b-tab>
                        <template #title>
                            interior design & décor consulting
                            <div class="list-bullet"></div>
                        </template>
                        <p class="text-white fade-right">
                            <span class="gotham-bold">
                                Interior Visceral Cutting
                            </span>
                            <br>
                            <br>
                            Our accredited team of interior designers has created and decorated some of the GTA's most-striking retail spaces, presentation centres, and custom homes. Their impeccable style and love for turning blank spaces into visceral experiences keeps them on design's cutting edge. 
                        </p>
                    </b-tab>
                    <b-tab>
                        <template #title>
                            signage design
                            <div class="list-bullet"></div>
                        </template>
                        <p class="text-white fade-right">
                            <span class="gotham-bold">
                                Art Rooted Demands
                            </span>
                            <br>
                            <br>
                            Signs, signs, everywhere there's signs! We've mastered the art of all forms of signage, plain and simple. It starts with a comprehensive strategic plan rooted in location. Then, we hone in on your brand voice, target demographic, and primary messaging. Adding creativity before bringing to a simmer, and you're left with a powerful, engaging, and concise deliverable that demands attention while educating the viewer. 
                        </p>
                    </b-tab>
                    <b-tab>
                        <template #title>
                            renderings
                            <div class="list-bullet"></div>
                        </template>
                        <p class="text-white fade-right">
                            <span class="gotham-bold">
                                Play Services Request 
                            </span>
                            <br>
                            <br>
                            Our rendering services go beyond simple coordination. They play a crucial part in the conceptualization, design, and realization of your project vision. From interior retail space renderings to pre-construction architectural depictions, we  provide high-quality and cost-effective services to create inspiring marketing deliverables. Whether it's a standalone asset or part of a comprehensive campaign, we do our utmost to ensure every one of our renderings meets the highest standards of excellence and accuracy. 
                        </p>
                    </b-tab>
                </b-tabs>
            </b-card>
        </b-container>
        <b-container fluid class="pt-4 d-md-none d-block px-4">
            <client-only>
                <slick
                ref="imgSlider"
                :options="whatWeDoSliderOptions"
                class="slick-for"
                >
                    <div 
                    v-for="(slide, i) in slides" 
                    class="" 
                    :key="i"
                    >
                        <p class="ga-pink gotham-bold">
                            {{ slide.heading }}
                        </p>
                        <p class="text-white gotham-bold mt-3">
                            {{ slide.subheading }}
                        </p>
                        <p class="text-white bodycopy-size gotham-book">
                            {{ slide.description }}
                        </p>
                    </div>
                </slick>
            </client-only>
        </b-container>
    </div>
</template>

<script>
import gsap from 'gsap';
export default {
    data() {
        return {
            tabIndex: 1,
            tabAnimation: null,
            whatWeDoSliderOptions: {
                fade: true,
                slidesToShow: 1,
                arrows: false,
                dots: false,
                infinite: true,
                vertical: false,
                lazyLoad: 'ondemand',
                verticalSwiping: false,
                asNavFor: null,
                autoplay: false,
                centerMode: false,
                autoplaySpeed: 6500,
                adaptiveHeight: false,
                appendDots: null,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            dots: false,
                            arrows: false,
                        }
                    }
                ]
            },
            slides: [
                {
                    heading: "project & corporate identity creation",
                    subheading: "Existing Eye Offerings",
                    description: "We build brands from the ground-up, while developing existing brands to reach their full potential. With a keen eye for striking design, in-depth research, and a unique voice for every brand we build and develop, we continue to create distinctive offerings that truly drive success."
                },
                {
                    heading: "print ad",
                    subheading: "People Print Dollars",
                    description: "Some people say print ads aren't worth the marketing dollars they generate. Those are the same people who don't know how to do it right. Print ads may be a forgotten art in today's digital age, but they still remain an immensely powerful tool to have in your toolbox. And we've been practicing since the 1980's. "
                },
                {
                    heading: "brochure design",
                    subheading: "Capture Invite Influence",
                    description: "When it comes to creating award-winning brochures, we do it by the book. Carefully considering every detail to produce engaging and informative pieces that capture your viewer's attention, and invites them in to discover something more. An indispensable resource that directly influences sales time after time."
                },
                {
                    heading: "direct mail designs & delivery",
                    subheading: "Egyptian Landowner Papyrus",
                    description: "Ah, print and digital direct mail. The lifeblood of advertising since 1000 B.C., when an Egyptian landowner scribbled an unsavory advertisement on a piece of papyrus. We've come a long way since then no doubt, but the power and application of this timeless marketing method remains. Only now, we can generate thousands of sales and even more leads faster than ever before. Sounds easy, right?"
                },
                {
                    heading: "website design & development",
                    subheading: "Wizards Bring Life",
                    description: "Our expert web team, or Web Wizards as we call them, handle everything throughout the development, management, and maintenance processes. They work closely alongside our designers and writers to bring the visions of your ideal website to life. With creation and hosting all done in-house, it's the one-stop-shop for all your website needs."
                },
                {
                    heading: "social media/content",
                    subheading: "Fingers Pulse Everything",
                    description: "The heart and soul of any contemporary campaign, our social media experts have their fingers on the pulse of everything #trending. From punchy, attention-grabbing posts to strategic planning, in-depth market research and more, our dedicated social team really does do it all."
                },
                {
                    heading: "marketing & digital advertising",
                    subheading: "Love Secret Strategies",
                    description: "Marketing is our first love, and in this day and age, digital advertising is our secret weapon. From proven far-reaching marketing strategies to Search Engine Optimization, curated digital ads, Google adwords, video ads, and more, our digital campaigns are award-winning. "
                },
                {
                    heading: "production, installation & fabrication",
                    subheading: "Relish Ketchup Mustard",
                    description: "We've got an actual workshop downstairs. That's how 'full-service' we are. With an in-house Production, Installation & Fabrication team dedicated to building the retail spaces and presentations centres of your dreams, we relish the opportunity to pursue your greatest ambitions. That might sound a little cheesy, but hey, we're one ketchup and mustard pun away from making you a burger."
                },
                {
                    heading: "media planning",
                    subheading: "Mr. T Planned Goals",
                    description: "We're not the only ones who love it when a plan comes together, Mr. T does too. Because, like us, he knows the importance and power a properly planned media schedule has on overall engagement and sales. Which is why we work closely alongside you to create effective plans that go beyond fulfilling your brand goals."
                },
                {
                    heading: "interior design & décor consulting",
                    subheading: "Interior Visceral Cutting",
                    description: "Our accredited team of interior designers has created and decorated some of the GTA's most-striking retail spaces, presentation centres, and custom homes. Their impeccable style and love for turning blank spaces into visceral experiences keeps them on design's cutting edge. "
                },
                {
                    heading: "signage design",
                    subheading: "Art Rooted Demands",
                    description: "Signs, signs, everywhere there's signs! We've mastered the art of all forms of signage, plain and simple. It starts with a comprehensive strategic plan rooted in location. Then, we hone in on your brand voice, target demographic, and primary messaging. Adding creativity before bringing to a simmer, and your left with a powerful, engaging, and concise deliverable that demands attention while educating the viewer. "
                },
                {
                    heading: "renderings",
                    subheading: "Play Services Request ",
                    description: "Our rendering services go beyond simple coordination. They play a crucial part in the conceptualization, design, and realization of your project vision. From interior retail space renderings to pre-construction architectural depictions, we  provide high-quality and cost-effective services to create inspiring marketing deliverables. Whether an asset within a comprehensive campaign or a standalone request, we do our utmost to ensure every one of our renderings meets the highest standards of excellence and accuracy. "
                }
            ]
        }
    },
    mounted() {
        this.tabAnimation = gsap;
    },
    watch: {
        tabIndex(newTab, oldTab) {
            if (newTab !== oldTab) {
                this.tabAnimation.from('.fade-right', {
                    opacity: 0,
                    x: 100,
                    duration: 0.3,
                    ease: 'Power4.inOut'
                })
            }
        }
    }
}
</script>

<style lang="scss">
#what-we-do {
    .card {
        position: relative;
        border: 0;
        background: transparent;
        border-radius: unset;

        .tab-content {
            display: flex;

            .active {
                display: flex;
                flex-direction: column;
                justify-content: center;
            }
        }

        .pink-divider {
            background: #ff56b1;
            width: 2px;
            height: 100%;
            position: absolute;
            left: 50%;
            top: 0;
        }

        .nav-pills {
            padding: 0 1.25rem;

            .nav-item {

                a {
                    background: transparent;
                    position: relative;
                    color: #ff56b1;
                    font-size: 1.25rem;
                }
                .nav-link {
                    padding: 0 1rem;
                    margin: 6px 0;
                }

                .nav-link.active {
                    color: #fff;

                    .list-bullet {
                        position: absolute;
                        top: 11px;
                        left: -24px;
                        background: #fff;
                        width: 10px;
                        height: 10px;
                        border-radius: 50%;
                    }
                }
            }
        }
    }

    
}
</style>